module.exports = __webpack_public_path__ + "img/finish.8cf49e9d.png";